import { render, staticRenderFns } from "./MatterportEmbed.vue?vue&type=template&id=29fe0c3b"
import script from "./MatterportEmbed.vue?vue&type=script&lang=js"
export * from "./MatterportEmbed.vue?vue&type=script&lang=js"
import style0 from "./MatterportEmbed.vue?vue&type=style&index=0&id=29fe0c3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports